// src/components/auth/MicrosoftButton.js
import React from 'react';

// Simple Microsoft-branded button component.
// Notes:
// - Avoids external image fetches; uses inline SVG for the MS logo.
// - Accepts loading/disabled states and passes click events upward.
export default function MicrosoftButton({ onClick, disabled, loading, className = '' }) {
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled || loading}
      className={
        `w-full flex items-center justify-center gap-3 border rounded-md py-2 px-4 font-semibold ` +
        `${disabled || loading ? 'bg-gray-100 text-gray-400 cursor-not-allowed' : 'bg-white hover:bg-gray-50 text-gray-800'} ` +
        `border-gray-300 shadow-sm ` +
        className
      }
      aria-label="Continue with Microsoft"
    >
      {/* Microsoft logo (4 color squares) */}
      <svg width="18" height="18" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden>
        <rect x="1" y="1" width="9.5" height="9.5" fill="#F25022" />
        <rect x="12.5" y="1" width="9.5" height="9.5" fill="#7FBA00" />
        <rect x="1" y="12.5" width="9.5" height="9.5" fill="#00A4EF" />
        <rect x="12.5" y="12.5" width="9.5" height="9.5" fill="#FFB900" />
      </svg>
      <span className="truncate">
        {loading ? 'Connecting to Microsoft...' : 'Continue with Microsoft'}
      </span>
    </button>
  );
}


